import { webConstants } from "@payping/utils/platformConstants";
import { safeJoinPath } from "@payping/utils/string";

const { DashboardRoutes } = webConstants;

interface ChangeLogType {
  links: string[][];
  version: string;
}

// for each new release note there should be an entry inside changeLog and another one inside translation files
// changeLog contains links to changed pages
// translations contain release note texts
export const changeLog: ChangeLogType[] = [
  {
    links: [[DashboardRoutes.user.terminals]],
    version: "1.8.0",
  },
  {
    links: [[DashboardRoutes.user.referral]],
    version: "1.7.0",
  },
  {
    links: [[]],
    version: "1.6.5",
  },
  // TODO: The link have to use blog utils constant
  {
    links: [[safeJoinPath(webConstants.BLOG_URL, "enamad")]],
    version: "1.6.0",
  },
  {
    links: [[DashboardRoutes.user.upgrade]],
    version: "1.5.10",
  },
  {
    links: [[DashboardRoutes.home.overview], [DashboardRoutes.report.transactions.root]],
    version: "1.3.0",
  },
  {
    links: [[]],
    version: "1.2.0",
  },
  {
    links: [[], [], []],
    version: "1.1.0",
  },
  {
    links: [
      [DashboardRoutes.home.overview],
      [DashboardRoutes.ipg.document],
      [DashboardRoutes.invoice.coupon.list],
      [DashboardRoutes.requestMoney.request],
      [DashboardRoutes.ipg.service.detail.replace(":name", "githubDonate")],
      [DashboardRoutes.ipg.root],
      [],
      [],
      [],
      [DashboardRoutes.report.itemSale],
      [DashboardRoutes.user.profile.root, DashboardRoutes.user.settings.root],
      [],
    ],
    version: "1.0.0",
  },
];
